import {lazy} from 'react';

export const ProfileFriendsAsync = lazy(() =>
    import('./ProfileFriends')
);
